/**
 * @desc 获取所有管理域
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  params: Params,
): Promise<defs.StandardReturn<Array<defs.QueryBaseInfoResponse>>> {
  return defHttp.get({
    url: '/wap/base/listBaseInfos',
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<Array<defs.QueryBaseInfoResponse>>> {
  return defHttp.get({
    url: '/mock/wap/base/listBaseInfos',
  });
}
